module.exports = __webpack_public_path__ + "staticcomp/img/marquee.7bf7cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/11/marquee.jpg
// module id = UShP
// module chunks = 39